import React, { useRef, useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createQueryString, getRandomColor } from '../../../../../../lib/utils';
import { fetchDefectsLoggedInJira } from '../../../../../../modules/dashboard';
import DefectsLoggedPerUser from './DefectsLoggedPerUser';
import DefectsLoggedPerStatus from './DefectsLoggedPerStatus';
import DefectAgingChart from './Defect Aging';

const DefectMetrics = ({
  projectId,
  isAdmin,
  setShowExport,
  dateFilters,
  isJiraIntegrated,
  selectedJiraProject,
}) => {
  const forceRefreshRef = useRef(false);
  const queryClient = useQueryClient();

  const queryKey = [
    'defectsLoggedInJira',
    projectId,
    dateFilters,
    selectedJiraProject?.linked_project_id,
  ];

  const {
    data: defectsData = [],
    isLoading,
    isFetching,
  } = useQuery({
    queryKey,
    enabled: isJiraIntegrated && !!selectedJiraProject,
    queryFn: async () => {
      const forceRefresh = forceRefreshRef.current;
      forceRefreshRef.current = false;
      const queryString = createQueryString(dateFilters);
      const jiraProjectId = selectedJiraProject?.linked_project_id;
      const res = await fetchDefectsLoggedInJira(projectId, queryString, jiraProjectId, forceRefresh);
      return res?.data || [];
    },
  });

  useEffect(() => {
    if (isJiraIntegrated && selectedJiraProject) {
      setShowExport(true)
    }
  }, [defectsData, isJiraIntegrated, selectedJiraProject]);

  const getPriorityColor = (priority) => {
    const priorityColors = {
      Highest: '#a93226',
      High: '#e74c3c',
      Medium: '#d68910',
      Low: '#2e86c1',
      Lowest: '#2e4053',
      Critical: '#ba4a00',
    };

    return priorityColors[priority] || getRandomColor();
  }

  const handleRefresh = () => {
    forceRefreshRef.current = true;
    queryClient.refetchQueries({ queryKey, exact: true });
  };

  return (
    <>
      {isAdmin && (
        <Col md={12}>
          <DefectsLoggedPerUser
            data={defectsData}
            dateFilters={dateFilters}
            loading={isLoading}
            isJiraIntegrated={isJiraIntegrated}
            getPriorityColor={getPriorityColor}
            handleRefresh={handleRefresh}
            isFetching={isFetching}
          />
        </Col>
      )}
      <Col md={6}>
        <DefectsLoggedPerStatus
          data={defectsData}
          dateFilters={dateFilters}
          loading={isLoading}
          isJiraIntegrated={isJiraIntegrated}
          getPriorityColor={getPriorityColor}
          handleRefresh={handleRefresh}
          isFetching={isFetching}
        />
      </Col>
      <Col md={6}>
        <DefectAgingChart
          data={defectsData}
          dateFilters={dateFilters}
          loading={isLoading}
          isJiraIntegrated={isJiraIntegrated}
          getPriorityColor={getPriorityColor}
          handleRefresh={handleRefresh}
          isFetching={isFetching}
        />
      </Col>
    </>
  );
};

export default DefectMetrics;
